export const reportsRoutes = [
    {
        path: 'reports/payroll/tax-summary-report',
        name: 'TaxSummaryReport',
        component: () => import('./views/TaxSummaryReport.vue')
    },
    {
        path: 'reports/payroll/pay-head-detail',
        name: 'PayHeadDetail',
        component: () => import('./views/PayHeadDetail.vue')
    },
    {
        path: 'reports/payroll/pay-head-summary',
        name: 'PayHeadSummary',
        component: () => import('./views/PayHeadSummary.vue')
    },
    {
        path: 'reports/payroll/pay-sheet',
        name: 'PaySheet',
        component: () => import('./views/PaySheet.vue')
    },
    {
        path: 'reports/payroll/pay-slip-detail',
        name: 'PaySlipDetail',
        component: () => import('./views/PaySlipDetail.vue')
    },
    {
        path: 'reports/payroll/pay-slip-summary',
        name: 'PaySlipSummary',
        component: () => import('./views/PaySlipSummary.vue')
    },
    {
        path: 'reports/banking/check-detail',
        name: 'CheckDetail',
        component: () => import('./views/CheckDetail.vue')
    },
    {
        path: 'reports/banking/deposit-detail',
        name: 'DepositDetail',
        component: () => import('./views/DepositDetail.vue')
    },
    {
        path: 'reports/banking/reconciliation-discrepancy',
        name: 'ReconciliationDiscrepancy',
        component: () => import('./views/ReconciliationDiscrepancy.vue')
    },
    {
        path: 'reports/banking/missing-checks',
        name: 'MissingChecks',
        component: () => import('./views/MissingChecks.vue')
    },
    {
        path: 'reports/inventory/inventory-details',
        name: 'InventoryDetails',
        component: () => import('./views/InventoryDetails.vue')
    },
    {
        path: 'reports/inventory/inventory-stock-status-by-item',
        name: 'InventoryStockStatusByItem',
        component: () => import('./views/InventoryStockStatusByItem.vue')
    },
    {
        path: 'reports/inventory/inventory-valuation-details',
        name: 'InventoryValuationDetails',
        component: () => import('./views/InventoryValuationDetails.vue')
    },
    {
        path: 'reports/inventory/inventory-valuation-summary',
        name: 'InventoryValuationSummary',
        component: () => import('./views/InventoryValuationSummary.vue')
    },
    {
        path: 'reports/fixed-asset/depreciation',
        name: 'DepreciationReport',
        component: () => import('./views/DepreciationReport.vue')
    },
    {
        path: 'reports/budget/vs-actuals',
        name: 'BudgetvsActualsReport',
        component: () => import('./views/BudgetvsActualsReport.vue')
    },
    {
        path: 'reports/budget/overview',
        name: 'BudgetOverviewReport',
        component: () => import('./views/BudgetOverviewReport.vue')
    },
    {
        path: 'reports/purchase/purchase-by-item-detail',
        name: 'PurchasebyItemDetail',
        component: () => import('./views/PurchasebyItemDetail.vue')
    },
    {
        path: 'reports/purchase/purchase-by-item-summary',
        name: 'PurchasebyItemSummary',
        component: () => import('./views/PurchasebyItemSummary.vue')
    },
    {
        path: 'reports/purchase/purchase-by-vendor-detail',
        name: 'PurchasebyVendorDetail',
        component: () => import('./views/PurchasebyVendorDetail.vue')
    },
    {
        path: 'reports/purchase/purchase-by-vendor-summary',
        name: 'PurchasebyVendorSummary',
        component: () => import('./views/PurchasebyVendorSummary.vue')
    },
    {
        path: 'reports/vendors-payables/vendor-transaction-history',
        name: 'VendorTransactionHistoryReport',
        component: () => import('./views/VendorTransactionHistoryReport.vue')
    },
    {
        path: 'reports/vendors-payables/vendors-statement',
        name: 'VendorsStatementReport',
        component: () => import('./views/VendorsStatementReport.vue')
    },
    {
        path: 'reports/vendors-payables/ap-aging-summary',
        name: 'AandPAgingSummaryReport',
        component: () => import('./views/AandPAgingSummaryReport.vue')
    },
    {
        path: 'reports/vendors-payables/ap-aging-detail',
        name: 'AandPAgingDetailReport',
        component: () => import('./views/AandPAgingDetailReport.vue')
    },
    {
        path: 'reports/sales/item-detail',
        name: 'SalesByItemDetail',
        component: () => import('./views/SalesByItemDetail.vue')
    },
    {
        path: 'reports/sales/item-summary',
        name: 'SalesByItemSummary',
        component: () => import('./views/SalesByItemSummary.vue')
    },
    {
        path: 'reports/sales/customer-detail',
        name: 'SalesByCustomerDetail',
        component: () => import('./views/SalesByCustomerDetail.vue')
    },
    {
        path: 'reports/sales/customer-summary',
        name: 'SalesByCustomerSummary',
        component: () => import('./views/SalesByCustomerSummary.vue')
    },
    {
        path: 'reports/customers-receivable/customer-transaction-history',
        name: 'CustomerTransactionHistoryReport',
        component: () => import('./views/CustomerTransactionHistoryReport.vue')
    },
    {
        path: 'reports/customers-receivable/client-statement',
        name: 'CustomerrStatementReport',
        component: () => import('./views/CustomerrStatementReport.vue')
    },
    {
        path: 'reports/customers-receivable/ar-aging-detail',
        name: 'AandRAgingDetailReport',
        component: () => import('./views/AandRAgingDetailReport.vue')
    },
    {
        path: 'reports/customers-receivable/ar-aging-summary',
        name: 'AandRAgingSummaryReport',
        component: () => import('./views/AandRAgingSummaryReport.vue')
    },
    {
        path: 'reports/company-finance/reconciliation',
        name: 'ReconciliationReports',
        component: () => import('./views/ReconciliationReports.vue')
    },
    {
        path: 'reports/company-finance/automatic-transactions',
        name: 'AutomaticTransactions',
        component: () => import('./views/AutomaticTransactions.vue')
    },
    {
        path: 'reports/company-finance/expense',
        name: 'ExpenseReport',
        component: () => import('./views/ExpenseReport.vue')
    },
    {
        path: 'reports/company-finance/general-ledger',
        name: 'GeneralLedgerReport',
        component: () => import('./views/GeneralLedgerReport.vue')
    },
    {
        path: 'reports/company-finance/income-by-customer',
        name: 'IncomeByCustomerDetail',
        component: () => import('./views/IncomeByCustomerDetail.vue')
    },
    {
        path: 'reports/company-finance/transaction-detail',
        name: 'TransactionDetailByAccount',
        component: () => import('./views/TransactionDetailByAccount.vue')
    },
    {
        path: 'reports/company-finance/trial-balance',
        name: 'TrialBalance',
        component: () => import('./views/TrialBalance.vue')
    },
    {
        path: 'reports/company-finance/balance-sheet',
        name: 'BalanceSheet',
        component: () => import('./views/BalanceSheet.vue')
    },
    {
        path: 'reports/company-finance/cash-flow',
        name: 'CashFlowReport',
        component: () => import('./views/CashFlowReport.vue')
    },
    {
        path: 'reports/company-finance/profit-loss',
        name: 'ProfitAndLoss',
        component: () => import('./views/ProfitAndLoss.vue')
    },
    {
        path: 'reports/company-finance/profit-loss/account-detail',
        name: 'ProfitAndLossAccountDetail',
        component: () => import('./views/ProfitAndLossAccountDetail.vue')
    },
    {
        path: 'reports/home',
        name: 'ReportsHome',
        component: () => import('./views/ReportsHome.vue')
    }
];
